import React, { useEffect, useRef } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import Header from './components/layout/Header.jsx';
import Footer from './components/layout/Footer.jsx';
import Landing from './pages/Landing.jsx';
import FeaturePage from './pages/FeaturePage.jsx';
import AboutPage from './pages/AboutPage.jsx';
import NotFound from './pages/NotFound.jsx';
import { FEATURES } from './content/features.js';
import './App.css';

/**
 * Root layout: header, page routes, footer. Each page renders its own <Seo>.
 * @returns {JSX.Element} Application shell
 */
function App() {
  const { pathname, hash, key } = useLocation();
  const previousPathname = useRef(pathname);

  // Start each new page at the top. If the link points to a section (e.g. /om-oss#kontakt),
  // go to that section instead: straight there on a new page, gliding when already on the page.
  useEffect(() => {
    const isNewPage = previousPathname.current !== pathname;
    previousPathname.current = pathname;
    const target = hash ? document.getElementById(decodeURIComponent(hash.slice(1))) : null;

    if (target) {
      target.scrollIntoView({ behavior: isNewPage ? 'instant' : 'auto' });
    } else if (isNewPage) {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    }
  }, [pathname, hash, key]);

  return (
    <div className="page">
      <Header />
      <main className="page-main">
        <Routes>
          <Route path="/" element={<Landing />} />
          {FEATURES.map((feature) => (
            <Route key={feature.id} path={feature.path} element={<FeaturePage feature={feature} />} />
          ))}
          <Route path="/om-oss" element={<AboutPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
